<!--
  One quiet line about the plan, for the places where it is the right thing to say.

  On an empty dashboard it tells a new account what it already has, which is the first time
  anyone learns a limit exists. After a session it says what the recording just cost. Neither
  is a warning; the banner handles those.
-->
<template>
  <p v-if="acc" class="ph" :class="tone">
    <template v-if="variant === 'post-call'">
      Storage used: <b>{{ acc.storage.usedLabel }}</b> of
      {{ acc.storage.allowedLabel }}.
    </template>
    <template v-else>
      You are on <b>{{ acc.planName }}</b
      >: {{ acc.storage.allowedLabel }} of storage and
      {{ acc.ai.allowedLabel }} of AI video a month.
    </template>
    <router-link to="/dashboard/account">Plan &amp; usage →</router-link>
  </p>
</template>

<script>
import {
  accountSummary,
  currentAccount,
  subscribeAccount,
} from '@/http/requests/account';

export default {
  name: 'PlanHint',
  props: {
    variant: { type: String, default: 'empty' },
  },
  data() {
    return { acc: currentAccount() };
  },
  computed: {
    tone() {
      if (!this.acc) return '';
      return this.acc.storage.tone === 'ok' ? '' : this.acc.storage.tone;
    },
  },
  created() {
    this.unsubscribe = subscribeAccount((acc) => {
      this.acc = acc;
    });
    accountSummary().catch(() => {});
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  },
};
</script>

<style scoped>
.ph {
  font-family: 'JetBrains Mono', monospace !important;
  font-size: 12.5px;
  color: #8a8a8a;
  margin: 0;
}
.ph b {
  color: #fff;
}
.ph.warn b {
  color: #f0c45a;
}
.ph.over b {
  color: #ef4444;
}
.ph a {
  color: #d7df23;
  margin-left: 8px;
  white-space: nowrap;
}
.ph a:hover {
  text-decoration: underline;
}
</style>
